// extracted by css-extract-rspack-plugin
var _1 = "TE3G1zfth3ErIQIx";
var _2 = "GXX5fOX5cXsvAmH_";
var _3 = "GXX5fOX5cXsvAmH_";
export { _1 as "dialog", _2 as "dialogBtn", _3 as "dialog__btn" }
